<div class="container">
    <div class="row">
      <div id="loader">
        <div class="row d-flex justify-content-center">
            <img class="col-md-6" src="./assets/icons/loader_v2.gif" alt="">
        </div>
      </div>
    </div>
  </div>
